import React from 'react';
import { Link } from 'react-router-dom';

import { Button, useAppLayoutContextConsumer, AddIcon, Page } from '@occc-app/design-system';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';

import { DisplayCategoriesTableContainer } from './DisplayCategoriesTableContainer';
import { breadcrumbLinks } from './constants';

import { routeCreator } from '../utils';

const PAGE_TITLE = 'Display Categories';

export const DisplayCategoryListPage = () => {
  useAppLayoutContextConsumer(breadcrumbLinks);

  const isUserPermittedToCreateDisplayCategory = useIsUserPermittedTo(
    Feature.DISPLAY_CATEGORY_CREATE,
  );

  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      pageHeaderProps={{
        title: PAGE_TITLE,
      }}
      actions={
        isUserPermittedToCreateDisplayCategory && (
          <Button
            color='secondary'
            variant='contained'
            component={Link}
            startIcon={<AddIcon />}
            to={routeCreator.create()}
            role='button'
          >
            create new display category
          </Button>
        )
      }
    >
      <DisplayCategoriesTableContainer />
    </Page>
  );
};
